
import ScheduleTable from './ScheduleTable';
import styles from './index.less';

 const PyDocSchedule = (props: any) => {
 
 const { yellowDoctorInfo,psName } = props;

  const data = yellowDoctorInfo?.yellowPagesDoctorDutyListDTO;
  if (!data) {
    return null;
  }

  return (
    <div className={styles.cardBox}>
      <div className={styles.title}>
        <div>{psName}线下门诊排班</div>
        <span className={styles.tip}>具体排班以医院号源信息为准</span>
      </div>
      <ScheduleTable data={data} />
    </div>
  );
};
export default PyDocSchedule;